import TarefasAPI from '../../api/tarefas';

const state = {
  records: [],
  meta: {
    total_count: 0,
    current_page: 1,
    total_pages: 1,
    overdue_count: 0,
    today_count: 0,
    week_count: 0,
    month_count: 0,
    completed_count: 0,
    pending_count: 0,
  },
  summary: {
    overdue_count: 0,
    today_count: 0,
    week_count: 0,
    month_count: 0,
    completed_count: 0,
    pending_count: 0,
    calendar_summary: {},
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getTarefas: $state => $state.records,
  getMeta: $state => $state.meta,
  getSummary: $state => $state.summary,
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  async get({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await TarefasAPI.get(params);
      commit('SET_RECORDS', response.data.tarefas);
      commit('SET_META', response.data.meta);
    } catch (error) {
      console.error('Error fetching tarefas:', error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit, dispatch }, data) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await TarefasAPI.create({ tarefa: data });
      commit('ADD_RECORD', response.data);
      dispatch('getSummary');
      return response.data;
    } catch (error) {
      console.error('Error creating tarefa:', error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit, dispatch }, { id, data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await TarefasAPI.update(id, { tarefa: data });
      commit('UPDATE_RECORD', response.data);
      dispatch('getSummary');
      return response.data;
    } catch (error) {
      console.error('Error updating tarefa:', error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async toggleStatus({ commit, dispatch }, id) {
    try {
      const response = await TarefasAPI.toggleStatus(id);
      commit('UPDATE_RECORD', response.data);
      dispatch('getSummary');
      return response.data;
    } catch (error) {
      console.error('Error toggling tarefa status:', error);
      throw error;
    }
  },

  async delete({ commit, dispatch }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await TarefasAPI.delete(id);
      commit('REMOVE_RECORD', id);
      dispatch('getSummary');
    } catch (error) {
      console.error('Error deleting tarefa:', error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async getSummary({ commit }) {
    try {
      const response = await TarefasAPI.getSummary();
      commit('SET_SUMMARY', response.data);
    } catch (error) {
      console.error('Error fetching summary:', error);
    }
  },
};

const mutations = {
  SET_RECORDS($state, records) {
    $state.records = records;
  },
  SET_META($state, meta) {
    $state.meta = meta;
  },
  SET_SUMMARY($state, summary) {
    $state.summary = summary;
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  ADD_RECORD($state, record) {
    $state.records.unshift(record);
  },
  UPDATE_RECORD($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records.splice(index, 1, record);
    }
  },
  REMOVE_RECORD($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
